<template>
    <v-container>
        <v-dialog v-model="dialog_elimnar" max-width="290">
            <v-card>
                <v-card-title class="headline">
                    {{ $t('msg_eliminar_file') }}
                </v-card-title>

                <v-card-text>
                    {{ $t('msg_eliminar_invitacion_2') }}
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" @click="dialog_elimnar = false">
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="deleteFile()">
                        {{ $t('Si') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('title_files') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent max-width="400px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on" @click="update = false, clean_fields()">
                        + {{ $t('add_file') }}
                    </v-btn>
                </template>
                <v-form @submit.prevent="update ?
                    updateFile(id_update) :
                    createFile()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('files') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn class="align-self-end" color="red" icon @click="dialog = false, clear()">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-text-field v-model="nombre" v-if="dialog" autofocus prepend-icon="insert_drive_file"
                                name="nombre" :counter="100" :maxlength="100" :label="'* ' + $t('display_name')"
                                :error-messages="errores.name_shown">
                            </v-text-field>
                            <div class="mb-3 ml-5" v-if="isOcrSupported(nombre)">
                                <v-chip small color="blue" text-color="white">
                                    <v-avatar class="blue darken-4">
                                        <v-icon small>check</v-icon>
                                    </v-avatar>
                                    validación automática
                                </v-chip>
                            </div>
                            <v-text-field v-model="instructions" prepend-icon="subject" name="instructions"
                                :counter="250" :maxlength="250" :label="$t('instructions_to_display')"
                                :error-messages="errores.instructions">
                            </v-text-field>
                            <v-checkbox v-model="change_password" v-if="update" disable name="change_password"
                                :label="$t('change_file')"></v-checkbox>
                            * {{ $t('file') }}<br>
                            <input type="file" id="file" ref="file"
                                :disabled="update && !change_password ? true : false"
                                v-on:change="handleFileUpload()" />
                            <v-alert :value=errores.file type="error" outline transition="scale-transition">
                                {{ errores.file }}
                            </v-alert>
                            <v-alert :value=oversized type="error" outline transition="scale-transition">
                                {{ $t('msg_oversized') }}
                            </v-alert>
                            <v-alert :value=alerta type="warning" outline transition="scale-transition">
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="clear(), dialog = false">{{ $t('cerrar') }}</v-btn>
                            <v-spacer />
                            <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{ $t('modificar')
                                }}</v-btn>
                            <v-btn v-else :disabled="oversized" :loading="loading" color="primary" type="submit">{{
                                $t('agregar')
                                }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex>
                <v-card-title>
                    {{ $t('files') }}
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="search" :label="$t('Buscar')" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :loading="loadingDataFiles" :items="files" :search="search"
                    :rows-per-page-text="$t('filas_por_pagina')" :rows-per-page-items="[
                        { text: '5', value: 5 },
                        { text: '10', value: 10 },
                        { text: '25', value: 25 },
                        {
                            text: this.$t('todos'),
                            value: -1
                        }]" class="elevation-1">
                    <template v-slot:items="props">
                        <td class="justify-center layout px-0">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon medium class="mr-2" v-on="on" @click="newPage(props.item.file)">
                                        search
                                    </v-icon>
                                </template>
                                <span>{{ $t('mostrar') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon medium class="mr-2" v-on="on" @click="fill_fields(props.item),
                                        update = true,
                                        dialog = true,
                                        change_password = false,
                                        id_update = props.item.id">
                                        edit
                                    </v-icon>
                                </template>
                                <span>{{ $t('modificar') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon medium color="red" v-on="on"
                                        @click="dialog_elimnar = true, id_update = props.item.id">
                                        delete
                                    </v-icon>
                                </template>
                                <span>{{ $t('eliminar') }}</span>
                            </v-tooltip>
                        </td>
                        <td>
                            {{ props.item.name_shown }}
                            <v-chip v-if="isOcrSupported(props.item.name_shown)" small color="blue" text-color="white"
                                class="ml-2">
                                <v-avatar class="blue darken-4">
                                    <v-icon small>check</v-icon>
                                </v-avatar>
                                validación automática
                            </v-chip>
                        </td>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                            {{ $t('ningun_resultado_1') }} "{{ search }}" {{ $t('ningun_resultado_2') }}
                        </v-alert>
                    </template>
                    <template v-slot:pageText="props">
                        {{ props.rowsPerPage }}
                        {{ $t('files') }} {{ props.pageStart }} - {{ props.pageStop }} {{ $t('prep_de') }} {{
                            props.itemsLength }}
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import '@/plugins/axios'
import store from '@/store'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

const FALLBACK_OCR_TYPES = [
    {
        "type_id": "curp",
        "name": "CURP",
        "description": "Constancia de la Clave Única de Registro de Población",
        "fields": ["curp", "nombre", "fecha_inscripcion", "folio", "entidad"]
    },
    {
        "type_id": "rfc",
        "name": "RFC / Constancia de Situación Fiscal",
        "description": "Constancia de Situación Fiscal emitida por el SAT",
        "fields": ["RFC", "razon_social", "nombre_comercial", "regimen_capital", "fecha_inicio", "estatus", "regimen_fiscal", "codigo_postal"]
    },
    {
        "type_id": "dc3",
        "name": "DC-3",
        "description": "Constancia de Competencias o Habilidades Laborales",
        "fields": ["nombre_trabajador", "curp_trabajador", "ocupacion", "puesto", "nombre_empresa", "rfc_empresa", "nombre_curso", "duracion_horas", "fecha_inicio", "fecha_fin", "area_tematica", "agente_capacitador"]
    },
    {
        "type_id": "opinion_cumplimiento",
        "name": "Opinión de Cumplimiento",
        "description": "Opinión del cumplimiento de obligaciones fiscales (32-D)",
        "fields": ["RFC", "razon_social", "sentido", "folio", "fecha_emision", "vigente"]
    },
    {
        "type_id": "cedula_sua",
        "name": "Cédula SUA",
        "description": "Cédula de Determinación de Cuotas del Sistema Único de Autodeterminación",
        "fields": ["registro_patronal", "RFC", "razon_social", "actividad", "bimestre", "fecha_proceso", "delegacion_imss", "subdelegacion_imss", "total_cotizantes", "total_rcv", "total_infonavit"]
    },
    {
        "type_id": "linea_captura_imss",
        "name": "Línea de Captura IMSS",
        "description": "Formato para pago de cuotas obrero patronales del IMSS",
        "fields": ["registro_patronal", "RFC", "razon_social", "delegacion", "subdelegacion", "periodo_imss", "bimestre_rcv", "fecha_limite", "total_pagar", "linea_captura", "folio_sua", "num_cotizantes"]
    }
];

export default {
    name: "files",
    data: () => ({
        alerta: false,
        dialog: false,
        update: false,
        id_update: 0,
        nombre: '',
        instructions: '',
        instructions_aux: '',
        file: '',
        id_empresa: '',
        errores: [],
        search: '',
        files: [],
        headers: [],
        loadingDataFiles: false,
        loading: false,
        dialog_elimnar: false,
        change_password: false,
        oversized: false,
        ocrSupportedTypes: []
    }),
    beforeUpdate() {
        this.headers = [
            {
                text: this.$t('acciones'),
                align: 'center',
                sortable: false,
                value: 'update'
            },
            {
                text: this.$t('display_name'),
                align: 'left',
                sortable: true,
                value: 'name_shown'
            }
        ]
    },
    computed: {
        ...mapState(['language']),
        ...mapGetters(['getProfile'])
    },
    created: function () {
        this.getFiles()
        this.get_extra_data()
        this.fetchOcrTypes()
    },
    methods: {
        getFiles: function () {
            this.loadingDataFiles = true
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/FileInvByCompany/ListCreate/',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.files = response.data
                    this.loadingDataFiles = false
                })
                .catch(error => {
                    this.loadingDataFiles = false
                    console.log(error)
                })

        },
        get_extra_data: function () {
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/empresas/administradores/user/' + store.getters.getProfile.id + '/',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.id_empresa = response.data[0].id_empresa
                })
                .catch(error => {
                    console.log(error)
                })

        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0]
            if (this.file.size > 1024 * 1024) {
                this.oversized = true
            } else {
                this.oversized = false
            }
        },
        createFile: function () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.loading = true
                    this.errores = []
                    var bodyFormData = new FormData()

                    bodyFormData.set('company', this.id_empresa)
                    bodyFormData.set('name_shown', this.nombre)
                    bodyFormData.set('instructions', this.instructions)
                    bodyFormData.append('file', this.file)
                    const config = {
                        method: 'post',
                        url: 'https://empresa-service.intrare.app/FileInvByCompany/ListCreate/',
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Accept-Language': this.language,
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: bodyFormData
                    };
                    axios(config)
                        .then(ok => {
                            this.loading = false
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('msg_file_added'))
                            this.getFiles()
                            this.dialog = false
                            setTimeout(this.clear, 3000)
                        })
                        .catch(error => {
                            this.loading = false
                            if (error.response.status == 400
                                && typeof error.response.data == "object"
                                && error.response.data)
                                this.errores = error.response.data
                        })
                }
            }).catch((e) => {
                console.log(e);// Failed
            });

        },
        updateFile: function (id) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.loading = true
                    this.errores = []
                    var bodyFormData = new FormData()

                    bodyFormData.set('company', this.id_empresa)
                    bodyFormData.set('name_shown', this.nombre)
                    if (this.instructions !== this.instructions_aux)
                        bodyFormData.set('instructions', this.instructions)
                    if (this.change_password === true) {
                        bodyFormData.append('file', this.file)
                    }
                    const config = {
                        method: 'patch',
                        url: 'https://empresa-service.intrare.app/FileInvByCompany/Detail&Update&Delete/' + id + '/',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language,
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: bodyFormData
                    };
                    axios(config)
                        .then(ok => {
                            this.loading = false
                            this.getFiles()
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('msg_file_update'))
                            this.dialog = false
                            setTimeout(this.clear, 3000);
                        })
                        .catch(error => {
                            this.loading = false
                            if (error.response.status == 400
                                && typeof error.response.data == "object"
                                && error.response.data)
                                this.errores = error.response.data
                        })
                }
            }).catch((e) => {
                console.log(e);// Failed
            });
        },
        deleteFile() {
            const config = {
                method: 'delete',
                url: 'https://empresa-service.intrare.app/FileInvByCompany/Detail&Update&Delete/' + this.id_update + '/',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.language,
                    'authorization': 'Token ' + store.getters.getToken
                },
            }
            axios(config).then(ok => {
                console.log('Archivo con ID = ', this.id_update + ' Eliminado Correctamente.')
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'warning')
                this.$store.commit('snackbar_change_message', this.$t('msg_file_delete'))
                this.getFiles()
                setTimeout(this.clear, 3000)
                this.dialog_elimnar = false
            })
                .catch(error => {
                    if (error.response.status == 400
                        && typeof error.response.data == "object"
                        && error.response.data)
                        this.errores = error.response.data
                })
        },
        clear: function () {
            this.alerta = false
            this.errores = []
            this.$validator.reset()
            this.$store.commit('snackbar_activate_false')
            this.$store.commit('snackbar_change_color', 'success')
        },
        fill_fields(item) {
            this.nombre = item.name_shown
            this.instructions_aux = item.instructions
            this.instructions = item.instructions
            this.file = ''
            document.getElementById("file").value = ""
        },
        clean_fields() {
            // console.log('si se ejecuta', this.$refs.file.name)
            this.nombre = ''
            this.instructions = ''
            document.getElementById("file").value = ""
            this.file = ''
            this.oversized = false
        },
        newPage(url) {
            window.open(url, '_blank')
        },
        async fetchOcrTypes() {
            try {
                const response = await axios.get('https://microservices.intrare.app/ocr/document/types/');
                if (response.data && Array.isArray(response.data)) {
                    this.ocrSupportedTypes = response.data;
                } else if (response.data && Array.isArray(response.data.types)) {
                    this.ocrSupportedTypes = response.data.types;
                } else {
                    console.warn('Unexpected OCR types format, using fallback.', response.data);
                    this.ocrSupportedTypes = FALLBACK_OCR_TYPES;
                }
            } catch (e) {
                console.error("Error fetching OCR types, using fallback.", e);
                this.ocrSupportedTypes = FALLBACK_OCR_TYPES;
            }
        },
        isOcrSupported(docName) {
            if (!docName || !this.ocrSupportedTypes || this.ocrSupportedTypes.length === 0) return false;

            docName = docName.toLowerCase();
            return this.ocrSupportedTypes.some(type => {
                const typeValue = typeof type === 'string' ? type : (type.type_id || type.type || '');
                const val = typeValue.toLowerCase();

                if (docName.includes(val)) return true;
                if (docName.includes(val.replace(/_/g, ' '))) return true;

                // Aliases
                if (val === 'cedula_sua' && docName.includes('sua')) return true;
                if (val === 'linea_captura_imss' && (docName.includes('linea') || docName.includes('captura'))) return true;
                if (val === 'opinion_cumplimiento' && docName.includes('opinion')) return true;

                return false;
            });
        }
    }
}
</script>

<style scoped></style>
